/**
 * API 응답 봉투 `{ success: true, data } | { success: false, error: { code, message } }` 해제 (BOOTH-74).
 * 봉투가 아니거나 JSON 이 아니면 code `HTTP_ERROR` + 상태 코드. features/Print/printJobApi.ts 의 unwrap 과 같은 규칙 —
 * 결제 이후 새 API 클라이언트는 이 헬퍼를 쓴다 (printJobApi 는 그대로 둠).
 */
interface ApiOk<T> { success: true; data: T }
interface ApiFail { success: false; error: { code: string; message: string } }

export class ApiEnvelopeError extends Error {
  readonly code: string;
  readonly httpStatus: number;
  constructor(code: string, message: string, httpStatus: number) {
    super(message);
    this.name = "ApiEnvelopeError";
    this.code = code;
    this.httpStatus = httpStatus;
  }
}

export async function unwrapEnvelope<T>(res: Response): Promise<T> {
  const body = (await res.json().catch(() => null)) as ApiOk<T> | ApiFail | null;
  if (!body || !body.success) {
    const code = body && !body.success ? body.error.code : "HTTP_ERROR";
    const message = body && !body.success ? body.error.message : `HTTP ${res.status}`;
    throw new ApiEnvelopeError(code, message, res.status);
  }
  return body.data;
}
